import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ternaryValue',
    standalone: false
})
export class TernaryValuePipe implements PipeTransform {
    static format(condition: boolean, truthyValue: string, falsyValue: string): string {
        return !!condition ? truthyValue : falsyValue;
    }

    transform(condition: boolean, truthyValue: string, falsyValue: string): string {
        return TernaryValuePipe.format(condition, truthyValue, falsyValue);
    }
}
